export function deserializeToObject<S, D>(serialized: S, deserialized: D): D {
  const deserializedCopy = { ...deserialized };
  Object.keys(serialized).filter((key) => key in deserialized)
    .forEach((key) => deserializedCopy[key] = serialized[key]);
  return deserializedCopy;
}
